export default __webpack_public_path__ + "static/media/Aylestone-fc.1182e45d.png";